import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// 首页落地页体系。置于 index.css 之后，确保 sx- 令牌可覆盖同名场景。
import './styles/x-system.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
